"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._GetConversation = exports._GetConfig = exports._SendLike = exports._SendDislike = exports._PerformRequest = exports._BaseUrl = void 0;
var backend_services_1 = require("@src/services/backend-services");
var ip_resolvement_service_1 = require("@src/services/ip-resolvement.service");
var document_translations_1 = require("@src/services/document-translations");
exports._BaseUrl = process.env.environment === 'dev'
    ? 'https://fitbot-dev-729907915433.europe-west3.run.app'
    : 'https://fitbot-729907915433.europe-west3.run.app';
var isBackendSuccessResponse = function (response) { return 'status' in response && response.status === 'success'; };
var normalizeWebchatResponse = function (payload) {
    if ('result' in payload) {
        return {
            response: payload.result.response,
            conversationId: payload.conversationId,
            suggestedReplies: payload.suggestedReplies,
            type: payload.result.type,
            fitbotAttachments: payload.result.type === 'response' ? payload.result.attachments : undefined,
        };
    }
    return {
        response: payload.response,
        conversationId: payload.conversationId,
        suggestedReplies: payload.suggestedReplies,
        initEvent: payload.initEvent,
    };
};
var _PerformRequest = function (tenant, conversationId, data, firstContact, initEvent) { return __awaiter(void 0, void 0, void 0, function () {
    var finalUrl, language, location, _a, response, result, payload;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                finalUrl = firstContact
                    ? "".concat(exports._BaseUrl, "/").concat(tenant, "/input/webchat-init")
                    : "".concat(exports._BaseUrl, "/").concat(tenant, "/input/webchat/").concat(conversationId);
                language = ((_d = (_c = (_b = navigator.languages) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : navigator.language) !== null && _d !== void 0 ? _d : 'de').trim().split(/[-_]/)[0].toLowerCase();
                if (!((_e = data.location) !== null && _e !== void 0)) return [3 /*break*/, 1];
                _a = _e;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, (0, ip_resolvement_service_1._ResolveIpToGPS)()];
            case 2:
                _a = (_f.sent());
                _f.label = 3;
            case 3:
                location = _a;
                return [4 /*yield*/, (0, backend_services_1.betterFetch)(finalUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(__assign(__assign(__assign(__assign({}, (initEvent ? { initEvent: initEvent } : {})), data), (location ? { location: location } : {})), (language ? { languageCode: language } : {}))),
                    })];
            case 4:
                response = _f.sent();
                if (!response.ok) {
                    if (response.status === 500) {
                        throw 'retryButton';
                    }
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return [4 /*yield*/, response.json()];
            case 5:
                result = (_f.sent());
                payload = isBackendSuccessResponse(result) ? result.data : result;
                return [2 /*return*/, normalizeWebchatResponse(payload)];
        }
    });
}); };
exports._PerformRequest = _PerformRequest;
var _SendDislike = function (tenant_1, chatId_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([tenant_1, chatId_1], args_1, true), void 0, function (tenant, chatId, path) {
        if (path === void 0) { path = ''; }
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    });
};
exports._SendDislike = _SendDislike;
var _SendLike = function (tenant_1, chatId_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([tenant_1, chatId_1], args_1, true), void 0, function (tenant, chatId, path) {
        if (path === void 0) { path = ''; }
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    });
};
exports._SendLike = _SendLike;
var _GetConfig = function (tenant_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([tenant_1], args_1, true), void 0, function (tenant, callerSettings) {
        var documentsUrl, config, effectiveSettings, language, translationPath, response, translations, error_1;
        if (callerSettings === void 0) { callerSettings = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    documentsUrl = "https://files.fittec.io/files/fitcloud-configs/data/".concat(process.env.environment === 'dev' ? 'dev/' : '').concat(tenant);
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)("".concat(documentsUrl, "/FitbotUIConfig.json"), {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!response.ok) {
                                            throw new Error('Network response was not ok ' + response.statusText);
                                        }
                                        return [4 /*yield*/, response.json()];
                                    case 1:
                                        result = _a.sent();
                                        if ((result === null || result === void 0 ? void 0 : result.status) === 'success' && (result === null || result === void 0 ? void 0 : result.data)) {
                                            return [2 /*return*/, result.data];
                                        }
                                        return [2 /*return*/, result];
                                }
                            });
                        }); })];
                case 1:
                    config = _a.sent();
                    effectiveSettings = callerSettings.debug ? __assign(__assign({}, config), callerSettings) : __assign(__assign({}, callerSettings), config);
                    language = (0, document_translations_1._GetDocumentTranslationLanguage)(effectiveSettings, effectiveSettings.defaultLanguage);
                    if (!language)
                        return [2 /*return*/, config];
                    translationPath = "translations/FitbotUIConfig-".concat(encodeURIComponent(language), ".json");
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)("".concat(documentsUrl, "/").concat(translationPath), { method: 'GET' })];
                case 3:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Failed loading Fitbot UI translations (".concat(response.status, ")."));
                    }
                    return [4 /*yield*/, response.json()];
                case 4:
                    translations = _a.sent();
                    (0, document_translations_1.mergeTranslatedPaths)(config, translations);
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.warn("Could not load optional Fitbot UI translations \"".concat(translationPath, "\"."), error_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, config];
            }
        });
    });
};
exports._GetConfig = _GetConfig;
var _GetConversation = function (tenant, conversationId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, backend_services_1.betterFetch)("".concat(exports._BaseUrl, "/").concat(tenant, "/conversations/").concat(conversationId, "/message-history"), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!response.ok) {
                                throw response;
                            }
                            return [4 /*yield*/, response.json()];
                        case 1:
                            result = _a.sent();
                            if ((result === null || result === void 0 ? void 0 : result.status) === 'success' && (result === null || result === void 0 ? void 0 : result.data)) {
                                return [2 /*return*/, result.data];
                            }
                            return [2 /*return*/, result];
                    }
                });
            }); })];
    });
}); };
exports._GetConversation = _GetConversation;
